import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  BackgroundColors,
  AbsoluteWhiteColors,
} from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';

const useStyles = createUseStyles(
  {
    '@keyframes fadeInScale': {
      from: {
        opacity: 0,
        transform: 'scale(0.95)',
      },
      to: {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
    previewContainer: {
      position: 'relative',
      borderRadius: CornerRadius.r12,
      overflow: 'hidden',
      backgroundColor: BackgroundColors.base,
      width: '100%',
      // aspectRatio set dynamically via inline style based on available height
      // No DS easing match for cubic-bezier(0.16, 1, 0.3, 1) — bespoke "out-expo"-style curve
      animation: '$fadeInScale 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
    },
    previewMedia: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'center',
      zIndex: 1,
    },
    previewImageBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      filter: 'blur(20px)',
      transform: 'scale(1.1)',
    },
    previewVideo: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'center',
      zIndex: 1,
      // Hide native controls iOS Safari may inject
      '&::-webkit-media-controls': {
        display: 'none !important',
      },
      '&::-webkit-media-controls-enclosure': {
        display: 'none !important',
      },
      '&::-webkit-media-controls-panel': {
        display: 'none !important',
      },
    },
    previewVideoBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      filter: 'blur(20px)',
      transform: 'scale(1.1)', // Prevent blur edges from showing
    },
    // Title overlay on preview
    titleOverlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: [Spacings.s8, Spacings.s12],
      background: `linear-gradient(to top, ${Effects.alpha80} 0%, transparent 100%)`,
      color: AbsoluteWhiteColors.base.default,
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.semibold,
      pointerEvents: 'none',
      zIndex: 2,
    },
    // Positioning wrapper for the audio toggle InlineButton overlay
    audioToggleWrapper: {
      position: 'absolute',
      top: Spacings.s8,
      right: Spacings.s8,
      zIndex: 2,
      display: 'inline-flex',
    },
    iconButton: {
      width: 32,
      height: 32,
      flex: '0 0 32px',
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      color: AbsoluteWhiteColors.base.default,
      transition: 'background-color 0.2s',
      [canHover]: {
        '&:hover': {
          backgroundColor: Effects.alpha80,
        },
      },
    },
  },
  { name: 'preview-section' }
);

export default useStyles;
